import {
  GET_SURVEY,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/surveys/id/get'
import type { SurveyDetails, SurveyDetailsParams } from 'app/common/types/surveys'
import type { CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import { useSurveyData } from './useSurveyData'

const defaultState: SurveyDetails | null = null

type Options = CommonDataOptions<SurveyDetails | null, SurveyDetailsParams>

export const useSurveyDetails = (options: Options) => {
  const res = useSurveyData({
    ...options,
    requestValue: GET_SURVEY,
    error: 'Не удалось получить результаты опроса',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
